// Silme onay modal'ı
import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

const DeleteConfirmModal = ({ 
  isOpen = false,
  title, 
  message, 
  onConfirm, 
  onClose,
  onCancel, 
  isLoading = false,
  checkboxLabel,
  requireCheckbox = false
}) => {
  const [checked, setChecked] = React.useState(false);
  const confirmDisabled = isLoading || (requireCheckbox && !checked);
  
  // Modal kapalıysa hiçbir şey render etme
  if (!isOpen) return null;
  
  // onCancel yoksa onClose kullan
  const handleCancel = onCancel || onClose;
  
  return (
    <div className="modal-overlay">
      <div className="modal-content delete-modal">
        {/* Modal header */}
        <div className="modal-header">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <FiAlertTriangle className="mr-2 text-yellow-400" size={20} />
              <h3 className="text-lg font-medium text-white">{title || "Silme Onayı"}</h3>
            </div>
            <button
              onClick={handleCancel}
              className="text-white hover:text-gray-300"
              disabled={isLoading}
            >
              <FiX size={20} />
            </button>
          </div>
        </div>

        {/* Modal body */}
        <div className="p-6 space-y-4">
          <p className="text-gray-700 dark:text-gray-300">{message || title}</p>
          {requireCheckbox && (
            <label className="flex items-start space-x-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="checkbox"
                className="mt-1 h-4 w-4 text-red-600 border-gray-300 rounded"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                disabled={isLoading}
              />
              <span>{checkboxLabel}</span>
            </label>
          )}
        </div>

        {/* Modal footer */}
        <div className="flex items-center justify-end space-x-3 px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={handleCancel}
            className="btn-secondary"
            disabled={isLoading}
          >
            İptal
          </button>
          <button
            onClick={onConfirm}
            className={confirmDisabled ? 'px-4 py-2 rounded-md bg-gray-400 text-white cursor-not-allowed' : 'btn-danger'}
            disabled={confirmDisabled}
          >
            {isLoading ? 'Siliniyor...' : 'Sil'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
